import React, { useState, useEffect, Fragment } from "react";
import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import UserPool from "UserPool";
import Alert from 'react-bootstrap/Alert';
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { useHistory } from "react-router-dom";
import Regex from "services/utils/regex/Regex";
import moment from "moment";
import LableInput from "components/input/lableInput/lableInput";
import "../login/login.scss";
const Login = () => {
  const history = useHistory();
  const [userId, setUserId] = useState("");
  const [pass, setPass] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [isSubmited, SetIsSubmited] = useState(false);
  const [isPassword, setIsPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [msg, setMsg] = useState({loginMsg: "", msgType: ""});
  const [tokenAvailability, setTokenAvailability] = useState(localStorage.getItem('email'));
  const [isError, setIsError] = useState("");

  useEffect(() => {
    if (tokenAvailability) {
      document.location.href='/home';
      return;
    }
    if (Regex.email.test(String(userId).toLowerCase())) {
      SetIsSubmited(false);
    } else {
      SetIsSubmited(true);
    }
  }, [userId]);

  useEffect(() => {
    const logoutStatus = localStorage.getItem('logout');
    const userLoginDate = localStorage.getItem('loginDate');
    let loginUrl = history.location.pathname;
    const loginDate = moment().format('MM-DD-YYYY');
    const dateCompare = moment(loginDate).isSameOrBefore(userLoginDate, 'day');
      if (tokenAvailability) {
        setMsg((state) => ({...state, loginMsg: "Login successfully!", msgType: "success"}))
      } 
      if (logoutStatus === 'yes' && loginUrl == '/login') {
        setMsg((state) => ({...state, loginMsg: "Logout successfully!", msgType: "danger"}))
      }
      if (dateCompare &&  loginUrl != '/login') {
        setMsg((state) => ({...state, loginMsg: "Session Expired!", msgType: "danger"}))
      }

      setTimeout(() => {
        setMsg("")
        localStorage.removeItem('logout');
        localStorage.removeItem('loginDate');
        localStorage.removeItem('token');
        localStorage.removeItem('email');
        localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.rajeev.idToken");
        localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.rajeev.accessToken");
        localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.rajeev.refreshToken");
        localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.rajeev.clockDrift");
        localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.LastAuthUser");
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("username");
      }, 5000)
  }, [localStorage.getItem('logout'), localStorage.getItem('loginDate')]);

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsLoading(true);
      const user = new CognitoUser({
        Username: userId,
        Pool: UserPool,
      });

      const authDetails = new AuthenticationDetails({
        Username: userId,
        Password: pass
      });

      user.authenticateUser(authDetails, {
        onSuccess: async (data) => { 
          console.log('user login success', data)
          setIsLoading(false);
          // await setAsync("userData", "res.data.userObj");
          // await setSession(data.idToken.jwtToken);
          const loginDate = moment().format('MM-DD-YYYY');
          localStorage.setItem("token", data.idToken.jwtToken);
          localStorage.setItem("email", data.idToken.payload.email);
          const userName = data.idToken.payload['cognito:username'];
          localStorage.setItem("username", userName);
          localStorage.setItem("loginDate", loginDate);
          history.push('/applications');
        },
        onFailure: (err) => {
          console.log('user login failed', err)
          console.log("onFailure : ", err);
          setIsError("both");
          setUserId("");
          setPass("");
          setIsLoading(false);
        },
        newPasswordRequired: (data) => {
          console.log("newPasswordRequired : ", data)
        }
      });  
    }
    catch(err) {     
      console.log('error', err.UserNotFoundException)
     }
  }

 
  useEffect(() => {
    if (userId != "") {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [isDisabled, userId]);
  const handleChangeUserId = (val) => {
    setUserId(val);
  };
  const handleChangePassword = (val) => {
    setPass(val);
  };
  return (
    <div>
      <div className="shapes">
        <div className="circle1"></div>
        <div className="circle2"></div>
        <div className="dot" style={{ backgroundColor: "rgb(20, 175, 197)", right: "11%", bottom: "7.5%", height: "10px", width: "10px" }}></div>
        <div className="dot" style={{ backgroundColor: "rgb(20, 200, 197)", right: "11%", bottom: "10%", height: "10px", width: "10px" }}></div>
        <div className="dot" style={{ backgroundColor: "rgb(20, 225, 197)", right: "11%", bottom: "12.5%", height: "10px", width: "10px" }}></div>
        <div className="dot" style={{ backgroundColor: "rgb(20, 250, 197)", right: "11%", bottom: "15%", height: "10px", width: "10px" }}></div>
        <div className="dot" style={{ backgroundColor: "rgb(20, 275, 197)", right: "11%", bottom: "17.5%", height: "10px", width: "10px" }}></div>
        <div className="dot" style={{ backgroundColor: "rgb(255, 250, 58)", right: "10%", bottom: "7.5%", height: "10px", width: "10px" }}></div>
        <div className="dot" style={{ backgroundColor: "rgb(255, 235, 58)", right: "10%", bottom: "10%", height: "10px", width: "10px" }}></div>
        <div className="dot" style={{ backgroundColor: "rgb(255, 220, 58)", right: "10%", bottom: "12.5%", height: "10px", width: "10px" }}></div>
        <div className="dot" style={{ backgroundColor: "rgb(255, 205, 58)", right: "10%", bottom: "15%", height: "10px", width: "10px" }}></div>
        <div className="dot" style={{ backgroundColor: "rgb(255, 190, 58)", right: "10%", bottom: "17.5%", height: "10px", width: "10px" }}></div>
        <div className="circle3" style={{ left: "30%", bottom: "25%" }}></div>
        <div className="circle4" style={{ left: "10%", top: "15%" }}></div>
        <div className="circle4" style={{ left: "11.5%", bottom: "5%", height: "40px", width: "40px" }}></div>
        <div className="background-layout">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="rgb(10 182 183)" fillOpacity="1" d="M0,0L20,16C40,32,80,64,120,80C160,96,200,96,240,90.7C280,85,320,75,360,80C400,85,440,107,480,117.3C520,128,560,128,600,138.7C640,149,680,171,720,202.7C760,235,800,277,840,256C880,235,920,149,960,138.7C1000,128,1040,192,1080,192C1120,192,1160,128,1200,128C1240,128,1280,192,1320,192C1360,192,1400,128,1420,96L1440,64L1440,0L1420,0C1400,0,1360,0,1320,0C1280,0,1240,0,1200,0C1160,0,1120,0,1080,0C1040,0,1000,0,960,0C920,0,880,0,840,0C800,0,760,0,720,0C680,0,640,0,600,0C560,0,520,0,480,0C440,0,400,0,360,0C320,0,280,0,240,0C200,0,160,0,120,0C80,0,40,0,20,0L0,0Z"></path></svg>
        </div>
      </div>
      <div className="gptw-logo">
        <img src={Images.gptw} alt="" />
      </div>
      <div className="avanse-logo-wrap">
        <img src={Images.logo} alt="" />
      </div>
      <div className="login-box fixed-pane">
        <div className="section-header" style={{ marginTop: 5, top: "5%" }}>
          <div className="container text-center">
          {msg ? <Alert key="danger" variant={msg.msgType}>
            {msg.loginMsg}
          </Alert> : null }
              <h1>{localization.signIn}</h1>
          </div>
        </div>
        <div className="body-wrapper">
          <div className="container">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <LableInput
    //              label={localization.userName}
                    label="Username or Email"
                  onChange={(e) => handleChangeUserId(e.target.value)}
                  type="text"
                  value={userId}
                  required
                  icon={Images?.username}
                  suggestion={(isError == 'both') ? localization.validUsername : ""}
                  isError={isError == 'both'}
                />
              </div>
              <div className="form-group marginTop">
                <LableInput
                  label={localization.password}
                  type="password"
                  value={pass}
                  onChange={(e) => handleChangePassword(e.target.value)}
                  required
                  icon={Images?.password}
                  suggestion={(isError == 'pass' || isError == 'both') ? localization.validPassword : ""}
                  isError={isError == 'pass' || isError == 'both'}
                />
              </div>
              <div className="form-group text-center">
                <button
                  type="submit"
                  className="btn btn-primary btn-full-width mt-4"
                  disabled={isDisabled}
                >
                  {isLoading ? 'Loading...' : localization.signIn}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
